import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Output,
  Input,
  EventEmitter,
} from "@angular/core";
import { Subscription } from "rxjs";
import { LanguagesService } from "src/app/services/languages.service";
import { ToggleService } from "src/app/services/toggle.service";
declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  constructor(private readonly toggleService: ToggleService ,private language :LanguagesService) {}
  @Output() toggleChatBotEv = new EventEmitter<number>();
  @Output() clearMessages = new EventEmitter<any>();
  subscription: Subscription = new Subscription;
  @Input() chatbot_lang;
  closeCount:number = 0
  ngOnInit() {
    this.subscription= this.language.get_language().subscribe(message=>{
      if(message.content){
        this.chatbot_lang=message.content;
      }else if (localStorage.getItem("chatbot_lang")){
        this.chatbot_lang=localStorage.getItem("chatbot_lang");
      }
      else {
        this.chatbot_lang = "en"
      }
    });
  }
  // toggleChatBot(num: number) {
  //     if (num == 2){
  //       this.clearMessages.emit();
  //       this.toggleRatingModelEV.emit()
  //       this.closeCount=this.closeCount+1
  //       num = 0;
  //     } else {
  //       this.toggleService.toggleChatbot(num);
  //     }
  // }
  toggleChatBot(num: number) {
    this.toggleService.toggleChatbot(num);
    $('.chatbot-toggle-icon').show();
    $('.chatbot-container').hide();
    parent.postMessage({ open : false }, '*');
    // localStorage.setItem("sessionId", undefined);
    // localStorage.setItem("chatbot_lang", undefined);
    localStorage.setItem("clientId", undefined);
    localStorage.setItem("phone", undefined);
    localStorage.setItem("name", undefined);
    localStorage.setItem("email", undefined);
    localStorage.setItem("dateOfBirth", undefined);
    window.localStorage.clear();
    // localStorage.clear();
  }
}
